import track from '~helpers/track'
import MarketoForm from '~components/MarketoForm'

const FORM_ID = '1184'
const PROGRAM_ID = 'PG1122A1'
const THANK_YOU_MESSAGE = `Thanks! Here's the link to <a href="https://www.gremlin.com/slack-invite">join the Chaos Engineering Slack</a>. The link has also been sent to your email.`

const SignUpForm = () => (
  <MarketoForm
    id={FORM_ID}
    fieldValues={{ programID: PROGRAM_ID }}
    onSuccess={() => {
      track('Event registered', {
        label: `marketo-${FORM_ID}`,
      })
    }}
    thankYouMessage={THANK_YOU_MESSAGE}
    scrollUpOnSubmission={false}
  />
)

const SlackSignUpForm = () => <SignUpForm />

export default SlackSignUpForm
